// extracted by mini-css-extract-plugin
export default {"webContents":"webContents_webContents__jFjmd","addBtn":"webContents_addBtn__ff8H5"};